<template>
  <b-modal
    id="cc-email-modal"
    @shown="getEmailCcStatusByEmail"
    centered
    size="md"
    close-on-backdrop
    hide-footer
    hide-header-close
    ref="emailModal"
  >
    <template #modal-header>
      <div class="addccEmail-header">
        <div class="text-center email-title-cc">
          <h4>Email Categories</h4>
        </div>
      </div>
    </template>
    <b-button
      variant="close-btn"
      class="btn-container"
      @click="closeModal"
      aria-label="Close Modal"
    >
      <i class="fas fa-times"></i>
    </b-button>
    <b-container fluid>
      <div class="addGroup-form ccEmail-form">
        <form @submit.prevent="onSubmit">
          <div class="form-group mb-3">
            <label class="form-label">Email:</label>
            <input type="text" class="form-control" :value="email" readonly />
          </div>
          <div class="form-group mb-3" v-if="emailCategories.length > 0">
            <label class="form-label">Select Email Categories:</label>
            <div class="checkbox-group row flex-column">
              <div
                v-for="domain in emailCategories"
                :key="domain.email_domain_id"
                class="custom-checkbox col-sm-6"
              >
                <input
                  type="checkbox"
                  :id="`checkbox-${domain.email_domain_id}`"
                  :value="domain.email_domain_id"
                  v-model="domain.cc_status"
                  @change="isBtnDisabled = !emailCategories.some(item => item.cc_status)"
                />
                <label :for="`checkbox-${domain.email_domain_id}`" class="custom-label">
                  {{ domain.text }}
                </label>
                <span v-b-tooltip.hover :title="domain.description">
                  <i
                    class="fas fa-info-circle"
                    style="cursor: pointer; margin-left: 10px; color: #007bff"
                  ></i>
                </span>
              </div>
            </div>
            <p class="text-info">
              <strong>Note:</strong>
              By selecting any of the checkboxes, you will be included in CC emails for the selected
              email categories.
            </p>
          </div>
          <div class="form-group text-center mb-3 mt-3">
            <b-button class="apply-btn px-4 py-2" :disabled="isBtnDisabled" type="submit">Apply</b-button>
          </div>
        </form>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
  import Api from "@/resource/Api";
  export default {
    name: 'EnableEmail',
    props: {
      email: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        emailCategories: [],
        isBtnDisabled: true,
      };
    },
    methods: {
      showModal() {
        this.$refs.emailModal.show();
      },
      closeModal() {
        this.reset();
        this.$emit('onCloseModal');
      },
      reset() {
        this.emailCategories = [];
      },
      onSubmit() {
        const payload = {
          group_admin_email: this.email,
          domains: this.emailCategories,
        };

        const url = `update-email-cc`;
        let loader = this.$loading.show();
        Api.post(url, payload)
          .then((res) => {
            this.reset();
            this.$emit('onSubmit', res.data.message);
          })
          .catch((err) => {
            this.$notify(err.response.data.message, "error"); 
          })
          .finally(() => {
            loader.hide();
          });
      },
      getEmailCcStatusByEmail() {
        const encodedEmail = encodeURIComponent(this.email);
        const url = `email-cc-status?email=${encodedEmail}`;
        // Delay to ensure the modal is fully rendered and avoid error "the maximum call stack size"
        setTimeout(() => {
          let loader = this.$loading.show();
          Api.get(url)
            .then((res) => {
              if(res.data.status === 'success') {
                this.emailCategories = res.data.data.domains;
              }
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              loader.hide();
            });
        }, 50);
      },
    },
    watch: {
      emailCategories(newData) {
        if (newData.length > 0) {
         const isEmptyCheckbox = newData.filter(item => item.cc_status);
         if( isEmptyCheckbox.length > 0) {
            this.isBtnDisabled = false;
          } else {
            this.isBtnDisabled = true;
          }
        }
      },
    },
  };
</script>
<style>
  .email-title-cc {
    width: 100%;
    padding-top: 15px;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .ccEmail-form {
    margin-top: -10px;
  }
  .custom-checkbox-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  .custom-checkbox input {
    accent-color: #007bff;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
  }
  .addGroup-form .form-label {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    cursor: pointer;
    display: inline-block;
  }
  .custom-label {
    margin-left: -5px;
    font-size: 15px !important;
  }
  #cc-email-modal .btn-container {
    position: absolute;
    top: -100px !important;
    right: -15px;
    background: #fff;
    color: #000;
    border: 0;
    box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
    border-radius: 60px;
    font-size: 18px;
    width: 45px;
    height: 45px;
    align-items: center;
    justify-content: center;
    display: flex;
  }
  #cc-email-modal .apply-btn {
    width: 100%;
    font-size: 16px;
    color: #fff;
    background: linear-gradient(#0cf, #1597b8 49%, #0567bc) !important;
    border: none;
    border-radius: 6px;
    justify-content: center;
    display: flex;
  }

  #cc-email-modal .custom-checkbox input[type='checkbox'] {
    position: relative;
    opacity: 1 !important;
    width: 14px;
    height: 14px;
    padding-left: 1rem;
  }

  @media (max-width: 768px) {
    #cc-email-modal .form-group {
      display: block !important;
    }
  }
</style>
